import React from "react";
import Button from "material-ui/Button";
import Paper from "material-ui/Paper";
import { withStyles } from "material-ui/styles";

import SurveyTable from "components/SurveyTable";
import BrowserCheck from "components/BrowserCheck";

const styles = () => ({
  container: {
    padding: 20,
    margin: "20px auto",
    width: 1100,
  },
  header: {
    display: "flex"
  },
  title: {
    margin: 0,
    flex: 1
  },
  main: {
    padding: 20
  },
  surveyTitle: {
    margin: "0 0 5px"
  },
  clear: {
    clear: "both"
  }
});

class SurveyList extends React.Component {
  componentWillMount() {
    this.props.fetchSurveyList();
  }

  statusColor(survey) {
    const { classes } = this.props;
    return classes[survey.statusColor()];
  }

  render() {
    const { classes, surveyList } = this.props;
    const { customerId, surveys } = surveyList;
    const { historyPush, clickAttrSetting } = this.props;

    return (
      <Paper className={classes.container}>
        <div className={classes.header}>
          <h2 className={classes.title}>ホーム</h2>
          <Button raised onClick={clickAttrSetting(customerId)}>
            アンケート属性設定
          </Button>
          <div className={classes.clear} />
        </div>

        <BrowserCheck />

        <div className={classes.main}>
          <h4 className={classes.surveyTitle}>アンケート一覧</h4>

          <SurveyTable surveys={surveys} historyPush={historyPush} />
        </div>
      </Paper>
    );
  }
}

export default withStyles(styles)(SurveyList);



// WEBPACK FOOTER //
// ./src/components/SurveyList.jsx